export { default as PicturesPage } from "./PicturesPage"
export { default as TradesPage } from "./TradesPage"
export { default as RemdataPage } from "./RemdataPage"
export { default as CommunicationsPage } from "./CommunicationsPage"
export { default as DamageCaseNavigation } from "./DamageCaseNavigation"
export { default as DamageCasePage } from "./DamageCasePage"
export { default as DamageCasePageHeader } from "./DamageCasePageHeader"
export { default as UnsentCasesNavigator } from "./UnsentCasesNavigator"
export { default as UnsentCasesPage } from "./UnsentCasesPage"



// WEBPACK FOOTER //
// ./src/features/damage-case/index.js